var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-dropzone", {
        ref: "myVueDropzone",
        attrs: { id: "dropzone", options: this.option },
        on: {
          "vdropzone-error": _vm.handleError,
          "vdropzone-success": _vm.handleSuccess,
          "vdropzone-file-added": _vm.handleFileAdded,
          "vdropzone-removed-file": _vm.handleRemovedFile
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "text-right m-t" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-warning m-w-120",
            attrs: { disabled: _vm.disableUpdloadFile, type: "button" },
            on: { click: _vm.updateFiles }
          },
          [_vm._v("アップロード")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn m-w-120",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                _vm.closeModal()
              }
            }
          },
          [_vm._v("閉じる")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info m-t-sm" }, [
      _c("b", { staticClass: "text-red" }, [
        _vm._v(
          "※ファイルのアップロードは「アップロード」ボタンを押すことで完了となります。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "※アップロードボタンを押した後、アップロード完了するまでしばらくお待ちください"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fb43816", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb43816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EvidenceImageInput.vue
// module id = null
// module chunks = 